import { useSelector } from 'react-redux';

import { AdminRedirectDto } from 'theSource/types';
import { useApiQuery } from 'theSource/utils';
import { selectIsAdmin, selectIsAuthenticated } from 'theSource/features';
import { GET_ADMIN_REDIRECT_QUERY_KEY } from './utils';

export interface UseAdminRedirectQueryOutput {
  admin?: AdminRedirectDto;
  isLoadingAdmin: boolean;
  isFetchingAdmin: boolean;
}

export const useAdminRedirectQuery = (): UseAdminRedirectQueryOutput => {
  const isAdmin = useSelector(selectIsAdmin);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const {
    data: admin,
    isLoading: isLoadingAdmin,
    isFetching: isFetchingAdmin,
  } = useApiQuery<AdminRedirectDto>({
    queryKey: GET_ADMIN_REDIRECT_QUERY_KEY,
    endpoint: '/pwa/admin_redirect',
    enabled: Boolean(isAdmin || isAuthenticated),
  });

  return { admin, isLoadingAdmin, isFetchingAdmin };
};
